import Button from 'react-bootstrap/Button';
import { MdArrowBack } from 'react-icons/md';

const BackToListButton = ({ onClick, children }) => (
  <Button
    variant='secondary'
    size='sm'
    className='mb-2 d-flex align-items-center'
    onClick={onClick}
  >
    <MdArrowBack size={18} style={{ marginRight: 6 }} />
    {children || 'Back'}
  </Button>
);

export default BackToListButton;
